/**
 * @Author: zachalam
 * @Date:   2017-01-13T14:07:06-08:00
 * @Last modified by:   zachalam
 * @Last modified time: 2017-01-24T11:01:04-08:00
 */

// determine which api to use?
export const api =
  process.env.REACT_APP_SDK_BASE_URL || (process.env.NODE_ENV === 'development' ? 'http://api-wyp.test/api' : '/api');
export const per_page = 24; // number of API results to allow per page

export const APP_ENV = process.env.REACT_APP_ENV === 'dev' ? 'test01' : process.env.REACT_APP_ENV;
export const MEMBER_URL = process.env.REACT_APP_MEMBER_URL || `https://members-${APP_ENV}.whatsyourprice.com`;

export const SITE_NAME = 'WhatsYourPrice';
export const SOCIAL_SITE_NAME = 'WhatsYourPrice';
export const SITE_ACRONYM = process.env.REACT_APP_NAME || 'wyp';
export const BASE_URL = `WhatsYourPrice.com`;
export const SITE_ID = process.env.REACT_APP_SITE_ID || 'wyp';
export const FULL_URL = process.env.REACT_APP_FULL_URL || 'https://www.whatsyourprice.com';
export const SOCIAL_LINKS = {
  FACEBOOK: `https://www.facebook.com/${SOCIAL_SITE_NAME}`,
  TWITTER: `https://twitter.com/${SOCIAL_SITE_NAME}`,
  INSTAGRAM: `http://instagram.com/${SITE_NAME === 'WhatsYourPrice' ? 'whatsyourpricedating' : SOCIAL_SITE_NAME}`,
};
export const MAX_NUMBER_PHOTOS = 20;
export const MAX_PHOTO_FILE_SIZE = 15 * 1024 * 1024;
export const EXPIRE_SEARCH_HOURS = 7200;

export const MAX_COOKIE_AGE = 7776000;
export const EXP_MESSAGE_DAYS = 60;

export const GOOGLE_AUTH = 'google';
export const APPLE_AUTH = 'apple';
export const FACEBOOK_AUTH = 'facebook';

export const apiRTNotify =
  process.env.REACT_APP_AWS_API_GATEWAY_RTNOTIFY_URL || 'https://realtimenotify-sandbox.rflxm.io';
export const apiRTNotifyKey =
  process.env.REACT_APP_AWS_API_GATEWAY_RTNOTIFY_KEY || '7SWtveETZfe2HVOV9K53rJx7GgMG08rprWjUQKh3';

export const PWA_PUBLIC_KEY =
  process.env.REACT_APP_PWA_PUBLIC_KEY ||
  'BG4pJF7ZfbPVleZJXv-CYLPBdQSpZCaInZyMOxHvx8WL1tuF5Y-qJk1X0M81_hBnQ_qtndyIbVQWp1P4zUngpZs';
export const s3BucketDirect =
  process.env.REACT_APP_S3_BUCKET || 'https://s3-us-west-1.amazonaws.com/wyp-dev/dev/images/';

export const s3BucketContentDir =
  process.env.REACT_APP_S3_BUCKET_CONTENT_DIR || 'https://contents-dev.whatsyourprice.com/images/site/';

export const notificationExpiration = process.env.NOTIFICATION_QUEUE_EXPIRATION || 1800; // notification queue expiration in seconds

export const googleMapKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
export const apiGiphyKey = process.env.REACT_APP_GIPHY_API_KEY || 'P53KmwGsXudBwgK2xHucNnDbUSupRdMr';
export const enabledPhotoMessage = process.env.REACT_APP_PHOTO_MESSAGE === 'true';
export const enabledOfferHighlights = process.env.REACT_APP_OFFER_HIGHLIGHTS_ENABLED === 'true';
export const enableBoostedProfiles = process.env.REACT_APP_BOOST_ENABLED === 'true';
export const billingMaintenance = process.env.REACT_APP_BILLING_MAINTENANCE === 'true';

export const allowedPostalLookupCountry = process.env.REACT_APP_POSTAL_LOOKUP_ALLOWED_COUNTRY || 'US';
export const countryWithTaxByProvince = process.env.REACT_APP_COUNTRY_WITH_TAX_BY_PROVINCE || 'CA';
export const enabledPostalLookup = process.env.REACT_APP_POSTAL_LOOKUP_ALLOWED_ENABLE === 'true';

export const MAX_SUBSCRIPTION_HRS = 24;

export const searchMicroserviceEnabled = process.env.REACT_APP_SEARCH_MICROSERVICE_ENABLED === 'true';
export const searchMicroserviceUrl =
  process.env.REACT_APP_SEARCH_MICROSERVICE_URL || 'https://search-sandbox.rflxm.io/search';
export const searchMicroserviceKey =
  process.env.REACT_APP_SEARCH_MICROSERVICE_KEY || '6e2a62f6-5745-4ad2-95ad-ee1b4cfe2cda';
export const searchMicroserviceBoost = process.env.REACT_APP_SEARCH_MICROSERVICE_BOOST === 'true';
export const messagingReminderEnabled = process.env.REACT_APP_MESSAGING_REMINDER === 'true';
export const auth10tixOrigin = process.env.REACT_APP_AUTH10TIX_ORIGIN || 'https://secure-me.au10tixservices.com';
export const auth10tixVerification = process.env.REACT_APP_AUTH10TIX_VERIFICATION === 'true';

export const vysionApiKey = process.env.REACT_APP_VYSION_API_KEY || 'd0285d1de9674404bb2584e018fbddbc';
export const vysionStage =
  process.env.REACT_APP_ENV === 'production' ? 'prod' : process.env.REACT_APP_ENV === 'test05' ? 'dev' : 'sandbox';
export const vysionEnabled = process.env.REACT_APP_VYSION_ENABLED === 'true' && process.env.REACT_APP_ENV !== 'dev'; //disable vysion if env is dev (local)

export const idvPurchaseEnabled = process.env.REACT_APP_IDV_PURCHASE === 'true';

export const DDC_FINGER_PRINTING_URL =
  process.env.REACT_APP_DDC_FINGER_PRINTING_URL || 'https://centinelapistag.cardinalcommerce.com';
export const DDC_FINGER_PRINTING_CLIENT_URL =
  process.env.REACT_APP_DDC_FINGER_PRINTING_CLIENT_URL || 'https://cas.client.cardinaltrusted.com';

export const GENERAL_MESSAGE_USERNAME = 'Administrator';
export const GENERAL_MESSAGE_AVATAR = `${s3BucketContentDir}admin_message_logo/2024/WYP_AdminAvatar_512.png`;

export const tomtomEnabled = process.env.REACT_APP_ENABLE_TOMTOM === 'true';
export const tomtomApiKey = process.env.REACT_APP_TOMTOM_API_KEY;

export const isProdEnv = process.env.REACT_APP_ENV === 'production';

export const ADDRESS_COMPLETER_MICROSERVICE_ENABLED = process.env.REACT_APP_ADDRESS_COMPLETER_MICROSERVICE_ENABLED;
// Note: This config is not use ADDRESS_COMPLETER_MICROSERVICE_URI
export const ADDRESS_COMPLETER_MICROSERVICE_URI =
  process.env.REACT_APP_ADDRESS_COMPLETER_MICROSERVICE_URI ||
  'https://outsourcer-sandbox.rflxm.io/v1/address/completer';
export const ADDRESS_COMPLETER_MICROSERVICE_CLIENT_ID =
  process.env.REACT_APP_ADDRESS_COMPLETER_MICROSERVICE_CLIENT_ID || '4cf8016b-6b58-47c2-909c-7eaad859545e';
export const LOCATIONS_MICROSERVICE_URI =
  process.env.REACT_APP_LOCATIONS_MICROSERVICE_URI || 'https://outsourcer-sandbox.rflxm.io/v2/location';
export const LOCATIONS_MICROSERVICE_CLIENT_ID =
  process.env.REACT_APP_LOCATIONS_MICROSERVICE_CLIENT_ID || '2f4968bf-7344-4c7b-bd04-8350ce1bc069';

export const WYP_GIF_LOADER = `${s3BucketContentDir}loader/wyp_imageloader.gif`;
export const WYP_PRIVATE_IMG_FALLBACK = `${s3BucketContentDir}private_img_fallback.png`;
export const PWA_ASSETS_URL = `${s3BucketContentDir}pwa/2024`;

export const IS_IPQA_ENABLED = process.env.REACT_APP_ENV !== 'local';
export const WYP_IPQS_KEY = process.env.REACT_APP_IPQS_KEY_WYP;

export const IS_LOCAL = process.env.REACT_APP_ENV === 'local';

export const APPLE_SITE_URL = process.env.REACT_APP_APPLE_SITE_URL || `https://members-${APP_ENV}.whatsyourprice.com`;
export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID || 'com.wyp.sso-sandbox';

export const DRAGYN_BASE_API_URL = process.env.REACT_APP_DRAGYN_BASE_API_URL || 'https://dragyn-sandbox.rflxm.io/v1';
export const DRAGYN_BASIC_AUTH = process.env.REACT_APP_DRAGYN_BASIC_AUTH;
export const DRAGYN_CONFIG_KEY = process.env.REACT_APP_DRAGYN_CONFIG_KEY;

export const SELFIE_FE_CONFIG_KEY = process.env.REACT_APP_SELFIE_FE_CONFIG_KEY; // "KEY"
export const SELFIE_FE_BASIC_AUTH = process.env.REACT_APP_SELFIE_FE_BASIC_AUTH; // "KEY:SECRET"

export const MESSAGE_SLS_URI = process.env.REACT_APP_MESSAGE_SLS_URI || 'https://messaging-sandbox.rflxm.io/v1';

export const MasterConfig = {
  api,
  per_page,
  BASE_URL,
  SITE_NAME,
  SITE_ACRONYM,
  SITE_ID,
  FULL_URL,
  MEMBER_URL,
  SOCIAL_LINKS,
  MAX_NUMBER_PHOTOS,
  MAX_PHOTO_FILE_SIZE,
  EXPIRE_SEARCH_HOURS,
  GOOGLE_AUTH,
  FACEBOOK_AUTH,
  apiRTNotify,
  apiRTNotifyKey,
  MAX_COOKIE_AGE,
  EXP_MESSAGE_DAYS,
  PWA_PUBLIC_KEY,
  notificationExpiration,
  apiGiphyKey,
  enabledOfferHighlights,
  enabledPhotoMessage,
  billingMaintenance,
  enabledPostalLookup,
  allowedPostalLookupCountry,
  MAX_SUBSCRIPTION_HRS,
  searchMicroserviceEnabled,
  messagingReminderEnabled,
  searchMicroserviceUrl,
  searchMicroserviceKey,
  enableBoostedProfiles,
  searchMicroserviceBoost,
  s3BucketDirect,
  s3BucketContentDir,
  auth10tixOrigin,
  auth10tixVerification,
  vysionApiKey,
  vysionStage,
  vysionEnabled,
  googleMapKey,
  idvPurchaseEnabled,
  DDC_FINGER_PRINTING_URL,
  DDC_FINGER_PRINTING_CLIENT_URL,
  tomtomEnabled,
  tomtomApiKey,
  isProdEnv,
  countryWithTaxByProvince,
  ADDRESS_COMPLETER_MICROSERVICE_ENABLED,
  ADDRESS_COMPLETER_MICROSERVICE_URI,
  ADDRESS_COMPLETER_MICROSERVICE_CLIENT_ID,
  IS_LOCAL,
  APPLE_CLIENT_ID,
  APPLE_SITE_URL,
  DRAGYN_BASE_API_URL,
  DRAGYN_BASIC_AUTH,
  DRAGYN_CONFIG_KEY,
  APP_ENV,
  SELFIE_FE_BASIC_AUTH,
  SELFIE_FE_CONFIG_KEY,
};

export default MasterConfig;
